import $ from 'jquery';
import Component from '../models/Component';

export default class FilterFaq extends Component {
  constructor(element, context) {
    super(element, context);

    this.selectedType = new URLSearchParams(window.location.search).get('faq_category') || '';
    this.init();
  }

  init() {
    const buttons = this.element.find('.cta-button').get();
    
    // Apply 'active_f' class based on the URL parameter
    buttons.forEach(button => {
      const category = button.getAttribute('data-category') || '';
      if (category === this.selectedType) {
        button.classList.add('active_f');
      } else {
        button.classList.remove('active_f');
      }

      // Set up event listener for click
      button.addEventListener('click', (event) => {
        const category = event.target.getAttribute('data-category') || '';
        this.filterFaq(category);

        // Add active_f class to the clicked button and remove it from others
        buttons.forEach(btn => {
          if (btn === event.target) {
            btn.classList.add('active_f');
          } else {
            btn.classList.remove('active_f');
          }
        });
      });
    });
  }

  filterFaq(category) {
    document.getElementById('faq_category_input').value = category;
    this.element.submit();
  }
}
